import React, { Component } from 'react'; 
import {Button, Table, InputGroup, Modal, FormControl} from 'react-bootstrap';
import _ from "lodash";
import 'react-picky/dist/picky.css'; // Include CSS

class SamplingLogic extends Component {
  constructor(props){
    super(props)
    this.state={
      duration:false, 
      editCategories:false,
      callmix:false,      
      nameExist:false,
      toggle:true,
      toggleA:false,
      toggleT:false,
      errmsg:false
      
    }
  }
  componentWillMount() {
    let selectedTemplateClone = _.cloneDeep(this.props.templates);
    let agentCategories, durationProp, natureOfCall,CallMixData, CallMixDataNature, CallMixDataDuration, CallMixDataType, auditTypeList=[];   
    if(_.has(selectedTemplateClone, "agentCategories")){
       agentCategories = selectedTemplateClone.agentCategories
    }
    if(_.has(selectedTemplateClone, "auditTypeList") && !_.isEmpty(selectedTemplateClone.auditTypeList)){
      auditTypeList = selectedTemplateClone.auditTypeList
    } else {
      if(!_.isEmpty(this.props.auditTypes) && !_.isEmpty(this.props.auditTypes.complianceTypeAudit)){
        _.map(this.props.auditTypes.complianceTypeAudit, obj =>{ auditTypeList.push({'auditType':obj, 'value':''}) }) 
      }
    }
    if(_.has(selectedTemplateClone, "callDurations")){
      durationProp = selectedTemplateClone.callDurations
      if(!_.isEmpty(durationProp)){
        this.setState({isDuration:true})
      }
      if(_.has(selectedTemplateClone, "callNatures")){
        natureOfCall = selectedTemplateClone.callNatures      
      }
      if(_.has(selectedTemplateClone, "callMixCategories")){
        CallMixData = selectedTemplateClone.callMixCategories
        CallMixDataNature = _.filter(selectedTemplateClone.callMixCategories, {auditCategory: "NATURE OF CALL"})
        CallMixDataDuration = _.filter(selectedTemplateClone.callMixCategories, {auditCategory: "DURATION OF CALL"})
        CallMixDataType = _.filter(selectedTemplateClone.callMixCategories, {auditCategory: "TYPE OF CALL"})
                  
      } else {
        if(!_.isEmpty(durationProp)){
          if(_.has(this.props.durationProp, "callMixCategories")){
            CallMixData = this.props.durationProp.callMixCategories
            CallMixDataNature = _.filter(this.props.durationProp.callMixCategories, {auditCategory: "NATURE OF CALL"})
            CallMixDataDuration = _.filter(this.props.durationProp.callMixCategories, {auditCategory: "DURATION OF CALL"})
            CallMixDataType = _.filter(this.props.durationProp.callMixCategories, {auditCategory: "TYPE OF CALL"})
          }
        }
    }    
    }   
    this.setState({durationProp:durationProp, natureOfCall:natureOfCall, CallMixData:CallMixData, CallMixDataNature: CallMixDataNature,
      CallMixDataDuration:CallMixDataDuration,CallMixDataType:CallMixDataType,
      agentCategories:agentCategories, auditTypeList:auditTypeList}, ()=>this.categoryUpdate(this.props.masterinventory)) 
  }
  categoryUpdate = (categories) => {
    const {agentCategories} = this.state;
    let agentCategory = _.cloneDeep(agentCategories);
    let data = [];
    _.map(categories, (obj) => {
       let x = _.find(agentCategory, {'category':obj.label})
       if(_.isEmpty(x)){
        data.push({'id': 0, 'category':obj.label,  'noOfCalls': 0, 'minScore': 0, 'maxScore': 0})
       }
     })
     if(!_.isEmpty(data)){
      agentCategory.push(...data)
      this.setState({agentCategories:agentCategory})
     }

  }

 
  handleDurationDouble = (e) => {
    this.setState({duration:true})
  }
  handleDuration = (e) => {
    this.setState({isDuration:e.target.checked})  
    let durationProp, natureOfCall,CallMixData, CallMixDataNature,CallMixDataDuration,CallMixDataType;
    if(_.isEmpty(this.state.durationProp)){
      if(_.has(this.props.durationProp, "callDurations")){
        durationProp =  _.cloneDeep(this.props.durationProp.callDurations)
      }
      if(_.has(this.props.durationProp, "callNatures")){
        natureOfCall =  _.cloneDeep(this.props.durationProp.callNatures)
      }
      if(_.has(this.props.durationProp, "callMixCategories")){
        CallMixData = this.props.durationProp.callMixCategories
        CallMixDataNature = _.filter(this.props.durationProp.callMixCategories, {auditCategory: "NATURE OF CALL"})
        CallMixDataDuration = _.filter(this.props.durationProp.callMixCategories, {auditCategory: "DURATION OF CALL"})
        CallMixDataType = _.filter(this.props.durationProp.callMixCategories, {auditCategory: "TYPE OF CALL"})
      }     
    }
    this.setState({durationProp:durationProp, natureOfCall:natureOfCall,CallMixData:CallMixData,
      CallMixDataNature: CallMixDataNature,CallMixDataDuration:CallMixDataDuration,CallMixDataType:CallMixDataType,})
  }

  handleDurationDoubleOut = (e) => {
    this.setState({duration:false})
  }
  handleCallMixDouble = (e) => {
    this.setState({callmix:true})
  }
  handleCallMixDoubleOut = (e) => {
    this.setState({callmix:false})
  }
  handleAgentCategories = (e, index)=>{
    const{agentCategories} = this.state;
    let indexed = agentCategories[index];
    indexed['noOfCalls'] = parseInt(e.target.value)
    //this.setState({agentCategories})
    // if(e.target.value === '0'){
    //   this.setState({['inputerror'+index]:true})
    // } else {
    //   this.setState({['inputerror'+index]:false})
    // }
    this.setState({agentCategories})
  }
  handleAuditypes = (e, index)=>{
    const{auditTypeList} = this.state;
    let indexed = auditTypeList[index];
    indexed['value'] = !_.isEmpty(e.target.value) ? parseInt(e.target.value) : ''
    this.setState({auditTypeList})
  }
  handleDurationMinMax = (e, index, prop)=>{  
    const{durationProp} = this.state;
    let indexed = durationProp[index];
    indexed[prop] =   !_.isEmpty(e.target.value) ? parseInt(e.target.value) : ''
    this.setState({durationProp})
  }
  handleDurationMax = (e, index, prop)=>{ 
    const{durationProp} = this.state;
    let indexed = durationProp[index];
      if(e.target.value > indexed['min'] && !_.isEmpty(e.target.value)){
        indexed[prop] = parseInt(e.target.value) 
        this.setState({'errmsg': false})
      } else {
        indexed[prop] = !_.isEmpty(e.target.value) ? parseInt(e.target.value) : ''
        this.setState({'errmsg': true})
      }
    this.setState({durationProp})    
  }
  handleTime = (e, index, prop)=>{
    let time = e.target.value;
    if (time.length < 6) { 
      time += ':00'; 
    }
    const{natureOfCall} = this.state;
    let indexed = natureOfCall[index];
    indexed[prop] = time
    this.setState({natureOfCall})
  }
  handlePercentageNature = (e, category, pid, prop) =>{
    const{CallMixData} = this.state;
    let totalPer =0;
    let indexed = _.find(CallMixData, {'audit_type':pid})
    indexed[prop] = !_.isEmpty(e.target.value) ? parseInt(e.target.value) : ''
    let categories = _.filter(CallMixData, {'auditCategory':category})
    _.map(categories, (obj) =>{
      totalPer=totalPer+obj.percentage
    })
    if(totalPer !== 100){
      this.setState({alertNature:true})
    } else {
      this.setState({alertNature:false})
    }
    this.setState({CallMixData})
  }
  handlePercentageDuration = (e, category, pid, prop) =>{
    const{CallMixData} = this.state;
    let totalPer =0;
    let indexed = _.find(CallMixData, {'audit_type':pid})
    indexed[prop] =  !_.isEmpty(e.target.value) ? parseInt(e.target.value) : ''
    let categories = _.filter(CallMixData, {'auditCategory':category})
    _.map(categories, (obj) =>{
      totalPer=totalPer+obj.percentage
    })
    if(totalPer !== 100){
      this.setState({alertDuration:true})
    } else {
      this.setState({alertDuration:false})
    }
    this.setState({CallMixData})
  } 
  handlePercentageType = (e, category, pid, prop) =>{
    const{CallMixData} = this.state;
    let totalPer =0;
    let indexed = _.find(CallMixData, {'audit_type':pid})    
    indexed[prop] =  !_.isEmpty(e.target.value) ? parseInt(e.target.value) : ''
    let categories = _.filter(CallMixData, {'auditCategory':category})
    _.map(categories, (obj) =>{
      totalPer=totalPer+obj.percentage
    })
    if(totalPer !== 100){
      this.setState({alerttype:true})
    } else {
      this.setState({alerttype:false})
    }
    this.setState({CallMixData})
  }
  handleHideSave = () => {
    this.setState({saveNew:false})
  }
  saveNewChanges = () => {
    if(this.state.errmsg === false){
     this.setState({saveNew:true})
    }    
  }
  handleChangeName= (e) => {
    this.setState({tempname:e.target.value})
  }
  handleAgentCategoriesScoring = (e, index, prop)=>{
    const{agentCategories} = this.state;
    let indexed = agentCategories[index];
    indexed[prop] =  !_.isEmpty(e.target.value) ? parseInt(e.target.value) : ''
    this.setState({agentCategories})
  }
  handleAgentCategoriesScoringMax = (e, index, prop)=>{
    const{agentCategories} = this.state;
    let indexed = agentCategories[index];  
    if(e.target.value > indexed['minScore'] || e.target.value === '0'){
      indexed[prop] =   !_.isEmpty(e.target.value) ? parseInt(e.target.value) : ''
      this.setState({'errmsg': false})
    } else {
      indexed[prop] =   !_.isEmpty(e.target.value) ? parseInt(e.target.value) : ''
      this.setState({'errmsg': true})
    }
    this.setState({agentCategories}) 
  }
  saveModal = (prop, close) => {
    const{CallMixData, alerttype, alertDuration, alertNature, auditTypeList} = this.state 
    
    // let validAgent = _.find(agentCategories, {noOfCalls:0})
    let validCallMix =  _.find(CallMixData, {percentage:0})
    let content;
    let Footer;
    let title;
    let auditValidate = true;
    _.map(auditTypeList,(aud,i)=>{
      if(_.isEqual(aud.value.length,0)){
        auditValidate = false;
      }
    })
    if((typeof validCallMix === 'undefined') || alerttype || alertDuration || alertNature){   
      if(alerttype ||  alertDuration || alertNature){
        content = (
          <p>Overall Sum of Call Mix Percentage should be equal to 100%</p>  
        )
        Footer =  (<Button onClick={close}> OK </Button>)
        title = 'Information'
      } else { 
        if(auditValidate === false){
          content = (
            <p>Need to fill all the Audit type in Compliance Audit categories</p>  
          )
          Footer =  (<Button onClick={close}> OK </Button>)
          title = 'Information'
        } else
        if(prop) {
          content = (
            <InputGroup><InputGroup.Prepend>
            <InputGroup.Text id="basic-addon1"><i class="fas fa-comment"></i>
            </InputGroup.Text>
            </InputGroup.Prepend><input  className='form-control'
            onChange={(e)=>this.handleChangeName(e)} placeholder='Template Name'
            value={this.state.tempname} type='text'/></InputGroup>   
          )
          Footer =  (<Button onClick={this.finalNew}> OK </Button>)
          title = 'Save Changes'
        }  else {
        content = (
          <p>Content of Template has been Modified need to Save the changes</p>  
        )
        Footer =  (<div>
          <Button onClick={this.saveChanges}> OK </Button> &nbsp;
          <Button onClick={this.props.closeModal}> Cancel </Button>  
        </div>)
        title = 'Save Changes'
        } }
    } else {
      if(alerttype ||  alertDuration || alertNature){
        content = (
          <p>Overall Sum of Call Mix Percentage should be equal to 100%</p>  
        )
        Footer =  (<Button onClick={close}> OK </Button>)
        title = 'Information'
      } else {
      content = (
        <p>Values assigned should be greater than Zero</p>  
      )
      Footer =  (<Button onClick={close}> OK </Button>)
      title = 'Information'
      }
    }
    return(<Modal show={true}
    onHide={close}
    dialogClassName="modal-90w shadowClass"
    size='md'
    aria-labelledby="contained-modal-title-vcenter"
    centered>          
    <Modal.Header closeButton><Modal.Title>{title}</Modal.Title></Modal.Header>
    <Modal.Body>
     {content}
     {this.state.nameExist ? <p className='RedColoring alignRight'>{'Template Name already Exist'}</p> : null}
    </Modal.Body>
    <Modal.Footer>
      {Footer}
    </Modal.Footer>
    </Modal>)
    
  }
 
  finalNew = () =>{
   const{agentCategories, durationProp, natureOfCall, auditTypeList, CallMixData} = this.state   
      let cc;
      if(!_.isEmpty(this.props.fullTemplate)){
          cc = this.props.fullTemplate.filter(obj =>
              _.includes(obj.templateTitle.toLowerCase(),this.state.tempname.toLowerCase()))
      }
      if(_.isEmpty(cc)){
        this.handleHideSave()
        this.props.closeModal()
        let obj = {}
        if(!_.isEmpty(agentCategories)){
          let agents = _.map(agentCategories, (obj) => {obj =_.omit(obj, 'id');   return obj})
          obj = Object.assign({}, {"agentCategories":agents})    
        }
        if(!_.isEmpty(durationProp)){
          let duration = _.map(durationProp, (obj) => {obj =_.omit(obj, 'id');   return obj})
          obj = Object.assign({...obj, "callDurations":duration})
        }
        if(!_.isEmpty(natureOfCall)){
          let nature = _.map(natureOfCall, (obj) => {obj =_.omit(obj, 'id');   return obj})
          obj = Object.assign({...obj, "callNatures":nature})
        }
        if(!_.isEmpty(CallMixData)){
          let CallMix = _.map(CallMixData, (obj) => {obj =_.omit(obj, 'id');   return obj})
          obj = Object.assign({...obj, "callMixCategories":CallMix})
        }    
        if(!_.isEmpty(auditTypeList)){
          let auditType = _.map(auditTypeList, (obj) => {obj =_.omit(obj, 'id');   return obj})
          obj = Object.assign({...obj, "auditTypeList":auditType})
         }
          let newplate = {
            'templateTitle': this.state.tempname,
            ...obj ,
            'mapped':false, 
          }
            this.props.action.TokenValidation()     
            this.props.action.addTemplate(newplate);  
      } else {
          this.setState({nameExist:true})
      }
      
  } 
  saveChanges = () => {
    const{agentCategories, durationProp, natureOfCall, CallMixData, auditTypeList} = this.state
    this.handleHideSave()
    this.props.closeModal()
    let obj = {}
    if(!_.isEmpty(agentCategories)){
      obj = Object.assign({}, {"agentCategories":agentCategories})    
    }
    if(!_.isEmpty(durationProp)){
     obj = Object.assign({...obj, "callDurations":durationProp})
    }
    if(!_.isEmpty(natureOfCall)){
     obj = Object.assign({...obj, "callNatures":natureOfCall})
    }
    if(!_.isEmpty(CallMixData)){
      obj = Object.assign({...obj, "callMixCategories":CallMixData})
    }
    if(!_.isEmpty(auditTypeList)){
     obj = Object.assign({...obj, "auditTypeList":auditTypeList})
    }

    let newtemplate = {
      'templateTitle':this.props.templates.templateTitle,
      'id':this.props.templates.id,
      'mapped': this.props.templates.mapped,
      ...obj
    }
    this.props.action.TokenValidation()     
    this.props.action.editTemplate(this.props.templates.templateTitle, newtemplate);
  }
 
  handledoubleClick = (e) => {    
    this.setState({editCategories:true})
  }
  handledoubleClickOut = (e) => {    
    this.setState({editCategories:false})
  }
  saveReconfirm = () => {
    if(this.state.errmsg === false){
     this.setState({reconfirm:true})  
    }  
  }
  handleHideSaveReconfirm = () => {
    this.setState({reconfirm:false})
  }
  handleNature = () =>{
    this.setState((prevState) =>{
      return {toggle: !prevState.toggle};
    })
  }
  handleCategories = () =>{
    this.setState((prevState) =>{
      return {toggleA: !prevState.toggleA};
    })
  }
  handleauditTypes = () =>{
    this.setState((prevState) =>{
      return {toggleT: !prevState.toggleT};
    })
  }
  handledoubleClickAudit = (e) => {    
    this.setState({audit:true})
  }
  handledoubleClickOutAudit = (e) => {    
    this.setState({audit:false})
  }
 
  render(){   
    const{edit} = this.props;
    let name = this.props.templates.templateTitle || this.props.templates.templateName
    const{duration, isDuration, callmix, agentCategories, durationProp, natureOfCall, CallMixDataNature, CallMixDataDuration, CallMixDataType, auditTypeList,audit, toggleT,
      editCategories, toggle, toggleA,  alerttype, alertDuration, alertNature} = this.state

      
    return(
      <div>       
      <Modal
      show={true}
      onHide={this.props.closeModal}
      dialogClassName="modal-120w"
      size="xl"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      >
      <Modal.Header closeButton>
      <Modal.Title id="example-custom-modal-styling-title">
        {edit ?
          <span>{'Edit Sampling Criteria --'+name}</span> : 'Create Sampling Criteria'}
      </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
        <h6 className={toggleA ? 'evalFormMargin': 'evalForm'} onClick={this.handleCategories} >
        {toggleA ? <i class="fas fa-caret-down"/> : <i class="fas fa-caret-right"/>} <b>AGENT CATEGORIES</b></h6>  
        <div className={toggleA ? 'assesmentShow': 'assesmentHide'}>                 
          <Table responsive>
              <thead onClick={this.handledoubleClickOut}>
                <th>AGENT CATEGORIES</th>
                <th>MIN AUDIT SCORE</th>
                <th>MAX AUDIT SCORE</th>
                <th>TARGET NO OF CALLS/MONTH</th>
              </thead>
              <tbody >
              {!_.isEmpty(agentCategories) ? _.map(agentCategories, (obj, index)=> {
                return(
                 <tr onDoubleClick={this.handledoubleClick}>
                   <td>{obj.category}</td>
                   <td>{editCategories ? <FormControl type='number' onChange={(e)=>this.handleAgentCategoriesScoring(e, index, 'minScore')}
                    value={obj.minScore === 0 ? 0 : obj.minScore}/> :obj.minScore}</td>
                  <td>{editCategories ? <FormControl type='number' onChange={(e)=>this.handleAgentCategoriesScoringMax(e, index, 'maxScore')}
                    value={obj.maxScore === 0 ? 0 : obj.maxScore}/> :obj.maxScore}
                    {((obj.maxScore < obj.minScore) && (!_.isNull(obj.maxScore))) ? <p className='RedColoring'>{'Max value should be greater than Min'}</p> : null}
                    </td>
                  <td>{editCategories ? <FormControl type='number' className={this.state['inputerror'+index] ? 'input-fail' : ''}
                     onChange={(e)=>this.handleAgentCategories(e, index)}
                    value={obj.noOfCalls}/> :obj.noOfCalls}                  
                  </td>
                 </tr>
                )
              }) : null
              }
              </tbody>
            </Table> 
        </div>
        <h6 className={toggle ? 'evalFormMargin': 'evalForm'} onClick={this.handleNature} >
        {toggle ? <i class="fas fa-caret-down"/> : <i class="fas fa-caret-right"/>} <b>NATURE AND DURATION OF CALL</b>
          <input type='checkbox'  checked={isDuration} className='accord' onClick={this.handleDuration}/></h6>  
        <div className={toggle ? 'assesmentShow': 'assesmentHide'}>           
          {isDuration ?
          <div>
            <Table responsive>
              <thead onClick={this.handleDurationDoubleOut}>
              <th>CALL DURATION</th>
              <th>MIN (in secs)</th>
              <th>MAX (in secs)</th>
              </thead>
              <tbody>
              { _.map(durationProp, (obj, index)=>{
              return(
              <tr onDoubleClick={this.handleDurationDouble} >
              <td>{obj.callDuration}</td>
              <td>{(duration) ? <FormControl type="number" onChange={(e)=>this.handleDurationMinMax(e, index, 'min')}
              value={obj.min === 0 ? 0 : obj.min}/> : obj.min}</td>
              <td>{(duration) ? <FormControl type="number" onChange={(e)=>this.handleDurationMax(e, index, 'max')}
              value={obj.max === 0 ? 0 : obj.max}/> : obj.max}
              {(obj.max < obj.min &&  (!_.isNull(obj.max))) ? <p className='RedColoring'>{'Max value should be greater than Min'}</p> : null}
              </td>
              </tr>
              )
              })
              }
              </tbody>
            </Table>
            <Table responsive>
              <thead onClick={this.handleDurationDoubleOut}>
                  <th>CALL NATURE</th>
                  <th>START TIME</th>
                  <th>END TIME</th>
              </thead>
              <tbody>
                { 
                  _.map(natureOfCall, (obj, index)=>{
                  return(
                  <tr onDoubleClick={this.handleDurationDouble} >
                  <td>{obj.callNature}</td>
                  <td>{(duration) ?
                  <FormControl type="time" step='2' onChange={(e)=>this.handleTime(e, index, 'startTime')} value={obj.startTime}/> 
                  : obj.startTime}
                  </td>
                  <td>{(duration) ? <FormControl type="time" step="1" onChange={(e)=>this.handleTime(e, index, 'endTime')}
                  value={obj.endTime}/> : obj.endTime}</td>                   
                  </tr>
                  )
                })
                }
              </tbody>
            </Table>
              &nbsp; <b>CALL MIX % DEFINITION</b>
              <Table responsive>
              <thead onClick={this.handleCallMixDoubleOut}>
              <th>AUDIT CATEGORY</th>
              <th>AUDIT TYPE</th>
              <th>PERCENTAGE</th>
              </thead>
              <tbody>
            { 
            _.map(CallMixDataNature, (obj, i)=>{                     
            return(
            <tr onDoubleClick={this.handleCallMixDouble}>
            <td>{obj.auditCategory}</td>
            <td>{obj.audit_type}</td>
            <td>{(callmix) ?<FormControl type = 'number' onChange={(e)=>this.handlePercentageNature(e, obj.auditCategory, obj.audit_type, 'percentage')}
            value={obj.percentage === 0 ? 0 : obj.percentage}/> : obj.percentage}
            {(alertNature === true  && i === 3) ? <span className='RedColoring'>'Overall Sum of the Percentage Nature of Call should be 100%'</span> :  null}
            </td>

            </tr>
            )
            })
            }</tbody>
            </Table>
            <Table responsive>
              <thead onClick={this.handleCallMixDoubleOut}>
              <th>AUDIT CATEGORY</th>
              <th>AUDIT TYPE</th>
              <th>PERCENTAGE</th>
              </thead>
              <tbody>
            { 
            _.map(CallMixDataDuration, (obj, i)=>{                     
            return(
            <tr onDoubleClick={this.handleCallMixDouble}>
            <td>{obj.auditCategory}</td>
            <td>{obj.audit_type}</td>
            <td>{(callmix) ?<FormControl type = 'number' onChange={(e)=>this.handlePercentageDuration(e, obj.auditCategory, obj.audit_type, 'percentage')}
            value={obj.percentage === 0 ? 0 : obj.percentage}/> : obj.percentage}
            {(alertDuration === true && i === 2) ? <span className='RedColoring'>'Overall Sum of the Percentage of Duration of Call should be 100%'</span> 
            :  null}
            </td>
            </tr>
            )
            })
            }</tbody>
            </Table>
            <Table responsive>
              <thead onClick={this.handleCallMixDoubleOut}>
              <th>AUDIT CATEGORY</th>
              <th>AUDIT TYPE</th>
              <th>PERCENTAGE</th>
              </thead>
              <tbody>
            { 
            _.map(CallMixDataType, (obj, i)=>{                     
            return(
            <tr onDoubleClick={this.handleCallMixDouble}>
            <td>{obj.auditCategory}</td>
            <td>{obj.audit_type}</td>
            <td>{(callmix) ?<FormControl type = 'number' onChange={(e)=>this.handlePercentageType(e, obj.auditCategory, obj.audit_type, 'percentage')}
            value={obj.percentage === 0 ? 0 : obj.percentage}/> : obj.percentage}  
             {(alerttype === true && i === 2)? <span className='RedColoring'>'Overall Sum of the Percentage of Type of Call should be 100%'</span> 
             :  null}         
            </td>
            </tr>
            )
            })
            }</tbody>
            </Table>   
          </div>
        : null}
      </div>

     <h6 className={toggleT ? 'evalFormMargin': 'evalForm'} onClick={this.handleauditTypes} >
        {toggleT ? <i class="fas fa-caret-down"/> : <i class="fas fa-caret-right"/>}<b> COMPLIANCE AUDIT CATEGORIES</b> </h6>  
        <div className={toggleT ? 'assesmentShow': 'assesmentHide'}>                 
          <Table responsive>
              <thead onClick={this.handledoubleClickOutAudit}>
                <th>AUDIT TYPE</th>
                <th>COUNT</th>
              </thead>
              <tbody >
              {!_.isEmpty(auditTypeList) ? _.map(auditTypeList, (obj, index)=> {
                return(
                 <tr onDoubleClick={this.handledoubleClickAudit}>
                   <td>{obj.auditType}</td>
                  <td>{audit ? <FormControl type='number' onChange={(e)=>this.handleAuditypes(e, index)}
                    value={obj.value}/> :obj.value}</td>
                 </tr>
                )
              }) : null
              }
              </tbody>
            </Table> 
        </div> 

      {edit ? <Button className='buttonwidth alignRight' onClick={this.saveReconfirm}>SAVE</Button>: null }
      &nbsp;
      <Button className='buttonwidth alignRight'  onClick={this.saveNewChanges}>SAVE AS</Button>
      {this.state.saveNew ? this.saveModal(true, this.handleHideSave) : null }
      {this.state.reconfirm ? this.saveModal(false, this.handleHideSaveReconfirm) : null }
    </div>        
      </Modal.Body>
      </Modal>       
      </div>
      );
  }

}

export default SamplingLogic

